export default "__VITE_ASSET__985cebfc__"